export interface RegisterTag {
  label: string;
  color: string;
}

export const REGISTER_TAGS: Record<string, RegisterTag> = {
  CAS:  { label: 'Casual',        color: '#f59e0b' },
  INF:  { label: 'Informal',      color: '#10b981' },
  NEU:  { label: 'Neutral',       color: '#6b7280' },
  STD:  { label: 'Standard',      color: '#64748b' },
  POL:  { label: 'Polite',        color: '#3b82f6' },
  FML:  { label: 'Formal',        color: '#8b5cf6' },
  FRM:  { label: 'Formal',        color: '#8b5cf6' },
  FOR:  { label: 'Formal',        color: '#7c3aed' },
  HON:  { label: 'Honorific',     color: '#2563eb' },
  ACA:  { label: 'Academic',      color: '#0891b2' },
  BUR:  { label: 'Bureaucratic',  color: '#78716c' },
  JUR:  { label: 'Legal',         color: '#b45309' },
  PUB:  { label: 'Public',        color: '#0d9488' },
  INT:  { label: 'Interview',     color: '#0369a1' },
  MSA:  { label: 'Std. Arabic',   color: '#059669' },
  LIT:  { label: 'Literary',      color: '#a855f7' },
  ARC:  { label: 'Archaic',       color: '#78716c' },
  ROY:  { label: 'Royal',         color: '#ca8a04' },
  SOV:  { label: 'Soviet-era',    color: '#dc2626' },
  REG:  { label: 'Regional',      color: '#9333ea' },
  DIAL: { label: 'Dialectal',     color: '#c026d3' },
  COL:  { label: 'Colloquial',    color: '#f97316' },
  SLG:  { label: 'Slang',         color: '#ec4899' },
  VUL:  { label: 'Vulgar',        color: '#ef4444' },
  HUM:  { label: 'Humorous',      color: '#eab308' },
  TEC:  { label: 'Technical',     color: '#06b6d4' },
  CF:   { label: 'Compare',       color: '#94a3b8' },
  IPA:  { label: 'IPA',           color: '#475569' },
};

export const TAG_LABELS_L10N: Record<string, Record<string, string>> = {
  ru: {
    CAS: 'Разговорный', INF: 'Неформальный', NEU: 'Нейтральный', STD: 'Стандартный',
    POL: 'Вежливый', FML: 'Формальный', FRM: 'Формальный', FOR: 'Формальный',
    HON: 'Почтительный', ACA: 'Академический', BUR: 'Бюрократический', JUR: 'Юридический',
    PUB: 'Публичный', INT: 'Интервью', MSA: 'Лит. арабский', LIT: 'Литературный',
    ARC: 'Архаичный', ROY: 'Королевский', SOV: 'Советский', REG: 'Региональный',
    DIAL: 'Диалектный', ROM: 'Романизация', PES: 'Персидский', TAG: 'Тагальский',
    COL: 'Просторечный', SLG: 'Сленг', VUL: 'Вульгарный', HUM: 'Шутливый',
    TEC: 'Технический', CF: 'Ср.', IPA: 'МФА',
  },
  es: {
    CAS: 'Casual', INF: 'Informal', NEU: 'Neutro', STD: 'Estándar',
    POL: 'Cortés', FML: 'Formal', FRM: 'Formal', FOR: 'Formal',
    HON: 'Honorífico', ACA: 'Académico', BUR: 'Burocrático', JUR: 'Jurídico',
    PUB: 'Público', INT: 'Entrevista', MSA: 'Árabe estándar', LIT: 'Literario',
    ARC: 'Arcaico', ROY: 'Real', SOV: 'Soviético', REG: 'Regional',
    DIAL: 'Dialectal', ROM: 'Romanización', PES: 'Persa', TAG: 'Tagalo',
    COL: 'Coloquial', SLG: 'Jerga', VUL: 'Vulgar', HUM: 'Humorístico',
    TEC: 'Técnico', CF: 'Cf.', IPA: 'AFI',
  },
  fr: {
    CAS: 'Familier', INF: 'Informel', NEU: 'Neutre', STD: 'Standard',
    POL: 'Poli', FML: 'Formel', FRM: 'Formel', FOR: 'Formel',
    HON: 'Honorifique', ACA: 'Académique', BUR: 'Bureaucratique', JUR: 'Juridique',
    PUB: 'Public', INT: 'Entretien', MSA: 'Arabe standard', LIT: 'Littéraire',
    ARC: 'Archaïque', ROY: 'Royal', SOV: 'Soviétique', REG: 'Régional',
    DIAL: 'Dialectal', ROM: 'Romanisation', PES: 'Persan', TAG: 'Tagalog',
    COL: 'Populaire', SLG: 'Argot', VUL: 'Vulgaire', HUM: 'Humoristique',
    TEC: 'Technique', CF: 'Cf.', IPA: 'API',
  },
  de: {
    CAS: 'Lässig', INF: 'Informell', NEU: 'Neutral', STD: 'Standard',
    POL: 'Höflich', FML: 'Formell', FRM: 'Formell', FOR: 'Formell',
    HON: 'Ehrerbietig', ACA: 'Akademisch', BUR: 'Bürokratisch', JUR: 'Juristisch',
    PUB: 'Öffentlich', INT: 'Interview', MSA: 'Hocharabisch', LIT: 'Literarisch',
    ARC: 'Archaisch', ROY: 'Königlich', SOV: 'Sowjetisch', REG: 'Regional',
    DIAL: 'Dialektal', ROM: 'Romanisierung', PES: 'Persisch', TAG: 'Tagalog',
    COL: 'Umgangssprachlich', SLG: 'Slang', VUL: 'Vulgär', HUM: 'Humorvoll',
    TEC: 'Technisch', CF: 'Vgl.', IPA: 'IPA',
  },
  ja: {
    CAS: 'カジュアル', INF: '非公式', NEU: '中立', STD: '標準',
    POL: '丁寧', FML: '正式', FRM: '正式', FOR: '正式',
    HON: '敬語', ACA: '学術', BUR: '官僚', JUR: '法律',
    PUB: '公的', INT: '面接', MSA: '正則アラビア語', LIT: '文語',
    ARC: '古語', ROY: '王族', SOV: 'ソ連時代', REG: '地方',
    DIAL: '方言', ROM: 'ローマ字', PES: 'ペルシア語', TAG: 'タガログ語',
    COL: '口語', SLG: '俗語', VUL: '卑語', HUM: 'ユーモア',
    TEC: '専門', CF: '参照', IPA: 'IPA',
  },
  ko: {
    CAS: '일상', INF: '비격식', NEU: '중립', STD: '표준',
    POL: '공손', FML: '격식', FRM: '격식', FOR: '격식',
    HON: '존경', ACA: '학술', BUR: '관료', JUR: '법률',
    PUB: '공식', INT: '인터뷰', MSA: '표준 아랍어', LIT: '문어',
    ARC: '고어', ROY: '왕실', SOV: '소련 시대', REG: '지역',
    DIAL: '방언', ROM: '로마자', PES: '페르시아어', TAG: '타갈로그어',
    COL: '구어', SLG: '은어', VUL: '비속', HUM: '유머',
    TEC: '전문', CF: '참조', IPA: 'IPA',
  },
  zh: {
    CAS: '隨意', INF: '非正式', NEU: '中性', STD: '標準',
    POL: '禮貌', FML: '正式', FRM: '正式', FOR: '正式',
    HON: '敬語', ACA: '學術', BUR: '官方', JUR: '法律',
    PUB: '公開', INT: '訪談', MSA: '標準阿拉伯語', LIT: '文言',
    ARC: '古語', ROY: '皇家', SOV: '蘇聯時期', REG: '地方',
    DIAL: '方言', ROM: '羅馬字', PES: '波斯語', TAG: '他加祿語',
    COL: '口語', SLG: '俚語', VUL: '粗俗', HUM: '幽默',
    TEC: '專業', CF: '參見', IPA: '國際音標',
  },
  ar: {
    CAS: 'عامّي', INF: 'غير رسمي', NEU: 'محايد', STD: 'معياري',
    POL: 'مؤدّب', FML: 'رسمي', FRM: 'رسمي', FOR: 'رسمي',
    HON: 'تشريفي', ACA: 'أكاديمي', BUR: 'بيروقراطي', JUR: 'قانوني',
    PUB: 'عام', INT: 'مقابلة', MSA: 'فصحى', LIT: 'أدبي',
    ARC: 'قديم', ROY: 'ملكي', SOV: 'سوفييتي', REG: 'إقليمي',
    DIAL: 'لهجي', ROM: 'رومنة', PES: 'فارسي', TAG: 'تاغالوغ',
    COL: 'دارج', SLG: 'عامية', VUL: 'بذيء', HUM: 'فكاهي',
    TEC: 'تقني', CF: 'قارن', IPA: 'ألفبائية صوتية',
  },
  th: {
    CAS: 'ลำลอง', INF: 'ไม่เป็นทางการ', NEU: 'กลาง', STD: 'มาตรฐาน',
    POL: 'สุภาพ', FML: 'เป็นทางการ', FRM: 'เป็นทางการ', FOR: 'เป็นทางการ',
    HON: 'ยกย่อง', ACA: 'วิชาการ', BUR: 'ราชการ', JUR: 'กฎหมาย',
    PUB: 'สาธารณะ', INT: 'สัมภาษณ์', MSA: 'อาหรับมาตรฐาน', LIT: 'วรรณกรรม',
    ARC: 'โบราณ', ROY: 'ราชาศัพท์', SOV: 'สมัยโซเวียต', REG: 'ภูมิภาค',
    DIAL: 'ถิ่น', ROM: 'อักษรโรมัน', PES: 'เปอร์เซีย', TAG: 'ตากาล็อก',
    COL: 'ภาษาพูด', SLG: 'สแลง', VUL: 'หยาบ', HUM: 'ขำขัน',
    TEC: 'เทคนิค', CF: 'เทียบ', IPA: 'สัทอักษรสากล',
  },
  pt: {
    CAS: 'Casual', INF: 'Informal', NEU: 'Neutro', STD: 'Padrão',
    POL: 'Polido', FML: 'Formal', FRM: 'Formal', FOR: 'Formal',
    HON: 'Honorífico', ACA: 'Acadêmico', BUR: 'Burocrático', JUR: 'Jurídico',
    PUB: 'Público', INT: 'Entrevista', MSA: 'Árabe padrão', LIT: 'Literário',
    ARC: 'Arcaico', ROY: 'Real', SOV: 'Soviético', REG: 'Regional',
    DIAL: 'Dialetal', ROM: 'Romanização', PES: 'Persa', TAG: 'Tagalo',
    COL: 'Coloquial', SLG: 'Gíria', VUL: 'Vulgar', HUM: 'Humorístico',
    TEC: 'Técnico', CF: 'Cf.', IPA: 'AFI',
  },
};

export const REGISTER_TAG_KEYS = Object.keys(REGISTER_TAGS);

export const REGISTER_TAG_RE = new RegExp(
  `^\\[(${REGISTER_TAG_KEYS.join('|')})\\]`
);

export function resolveTagLabel(tag: string, baseLang?: string): string {
  if (baseLang && baseLang !== 'en') {
    const l10n = TAG_LABELS_L10N[baseLang];
    if (l10n?.[tag]) return l10n[tag];
  }
  return REGISTER_TAGS[tag]?.label ?? tag;
}
